
import React, { MouseEventHandler } from "react";

type captionProps = {
  children:  React.ReactElement | any;
  bold?: boolean;
  fontType?: string;
  color?: string;
  classes?: string;
  id?: string;
  [key: string]: any
};

const Caption: React.FC<captionProps> = ({
  children,
  bold,
  color = "text-blueishblack",
  fontType = "regular",
  classes = "",
  ...rest
}): React.ReactElement => {
  const _fType = bold ? "bold" : fontType;

  return (
    <h6 className={`text-base w-full text-left ${color} ${classes}`} {...rest}>
      {children}
    </h6>
  );
};

export default Caption;
